<template>
  <div id="toolBtn">
    <div class="suspension_btn">
      <div class="action_btn" @mousemove="codeMousemove" @mouseout="codeMouseout" @mouseleave="codeMouseout"></div>
      <div class="code_btn">
        <transition name="fade">
          <div class="code_view" v-if="isShowCode">
            <h4 class="code_title">扫码二维码下载app</h4>
            <div class="ios_code" style="paiinf-bottom:15px">
              <img src="https://lximg.eiceducation.com.cn/img/092bdce2c09e4adc84b2c64ea46b72b1" alt="" class="img" />
              <p class="code_desc">iOS</p>
            </div>
            <div class="ios_code">
              <img src="https://kpimg.eiceducation.com.cn/school_img/09e016110a4e43ce96291591f102d7f4" alt="" class="img" />
              <p class="code_desc">Android</p>
            </div>
          </div>
        </transition>
      </div>
      <div class="feeb_back_btn" @click.stop="openFeedBack"></div>
      <transition name="fade">
        <!-- <div class="top_btn" @click.stop="backtop" v-if="inShowTop"></div> -->
        <div class="top_btn" @click.stop="backtop" :style="{ visibility: inShowTop ? 'visible' : 'hidden' }"></div>
      </transition>
    </div>
    <!-- modal_title_circle modal_up_img -->
    <my-modal ref="myModal" :isClickBgcClose="false">
      <template #modalHeader>
        <div class="feed_back_header">
          <div class="close_view" @click="modalChannel">
            <img src="@/assets/index/modal_close.png" alt="" />
          </div>
          <div class="title_view">
            <img src="@/assets/index/modal_title_circle.png" alt="" class="title_left" />
            <div class="title_value">问题反馈</div>
            <img src="@/assets/index/modal_title_circle.png" alt="" class="title_right" />
          </div>
        </div>
        <div class="title_border"></div>
      </template>
      <template #modalMIddle>
        <el-form :model="feedBackForm" ref="feedBackForm" class="feedBackForm">
          <el-form-item prop="Remark" :rules="[{ required: true, message: '问题和意见不能为空' }]">
            <div class="el_form_item_title">
              <span class="required_tip">※</span> 问题和意见
            </div>
            <el-input type="textarea" v-model="feedBackForm.Remark" :rows="5" placeholder="请填写10个字以上的问题描述以便我们更好的了解问题"
              autocomplete="off" maxlength="100" show-word-limit></el-input>
          </el-form-item>
          <el-form-item prop="fileList">
            <div class="el_form_item_title">
              上传截图：
            </div>
            <el-upload accept="image/jpeg,image/jpg,image/png,image/gif" class="upload_demo" list-type="picture"
              :on-preview="handlePreview" :on-exceed="handleExceed" :on-remove="handleRemove"
              :file-list="feedBackForm.fileList" drag :limit="10"
              action="https://schoolapi.eiceducation.com.cn/api/image" :on-success="handleSuccess"
              :on-change="handleChange" :headers="{
                token: tokenkey
              }" multiple>
              <img src="@/assets/index/modal_up_img.png" alt="" class="img_up" />
              <div class="up_btn">
                <el-button type="primary">点击选择图片</el-button>
              </div>
              <div class="up_tip">或将照片拖到这里，最多可选10张</div>
            </el-upload>
          </el-form-item>
          <el-form-item prop="Phone">
            <div class="el_form_item_title">
              联系电话（选填，便于我们与您联系）
            </div>
            <el-input v-model="feedBackForm.Phone" placeholder="请输入联系电话" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #modalFooter>
        <div class="feed_back_footer">
          <div class="btn btn_1" @click="modalChannel">取消</div>
          <div class="btn btn_2" @click="modalSubmit">提交</div>
        </div>
      </template>
    </my-modal>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
  import myModal from "@/components/myModal.vue";
  export default {
    components: {
      myModal
    },
    data() {
      return {
        dialogVisible: false,
        dialogImageUrl: "",
        inShowTop: false,
        isShowCode: false,
        tokenkey: "",
        feedBackForm: {
          Phone: "",
          Remark: "",
          fileList: [],
          fileListTemp: []
        },
        btnDisabled: false
      };
    },
    mounted() {
      window.addEventListener("scroll", this.showbtn, true);
    },
    created() {
      this.tokenkey = this.$cookies.get("token");
    },
    methods: {
      codeMousemove() {
        this.isShowCode = true;
      },
      codeMouseout() {
        this.isShowCode = false;
      },
      showbtn() {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop < 300 && this.inShowTop) {
          this.inShowTop = false;
        } else if (scrollTop >= 300 && !this.inShowTop) {
          this.inShowTop = true;
        }
      },
      openFeedBack() {
        this.$refs.myModal.isShowModal = true;
      },
      backtop() {
        var timer = setInterval(function() {
          let osTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            osTop + ispeed;
          if (osTop === 0) {
            clearInterval(timer);
          }
        }, 30);
      },
      modalChannel() {
        this.$refs.myModal.isShowModal = false;
        this.$set(this, 'feedBackForm', {
          Phone: "",
          Remark: "",
          fileList: [],
          fileListTemp: []
        })
        this.$refs["feedBackForm"].resetFields();
      },
      modalSubmit() {
        console.log('this.btnDisabled', this.btnDisabled);
        if (this.btnDisabled) {
          this.$message.error('正在上传图片，请稍等...')
          return
        }
        this.$refs["feedBackForm"].validate(valid => {
          console.log("valid", valid);
          if (valid) {
            console.log("this.$refs[", this.feedBackForm);
            let parameter = {
              Phone: this.feedBackForm.Phone || "",
              Remark: this.feedBackForm.Remark || "",
              ImgUrl: this.feedBackForm.fileListTemp.length > 0 ?
                this.feedBackForm.fileListTemp.join() :
                ""
            };
            this.$http.post("https://schoolapi.eiceducation.com.cn/api/FeedBack", parameter, {
              headers: {
                token: this.tokenkey
              }
            }).then(res => {
              if (res.data.succ) {
                this.$message.success(res.data.msg)
                this.modalChannel()
              } else {
                this.$message.error(res.data.msg)
                console.log('111111111111111111111111111');
              }
            })
          }
        });
      },
      handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleExceed() {
        this.$message.warning("截图最多可选10张");
      },
      handleSuccess(file) {
        console.log("file", file);
        if (file.succ) {
          this.feedBackForm.fileListTemp.push(file.results);
          console.log('this.feedBackForm.fileListTemp', this.feedBackForm.fileListTemp);
        }
      },
      handleRemove(file) {
        console.log("file", file);
        if (file.status == "success") {
          let {
            response: {
              results
            }
          } = file;
          let index = this.feedBackForm.fileListTemp.indexOf(results);
          if (index > -1) {
            this.feedBackForm.fileListTemp.splice(index, 1);
          }
        }
      },

      handleChange(file, fileList) {
        console.log('fileList', fileList);
        console.log('fileList1111111', fileList.every(item => item.percentage != 100));
        if (fileList.every(item => item.response)) {
          this.btnDisabled = false;
        } else {
          this.btnDisabled = true;
        }
        console.log('this.btnDisabled', this.btnDisabled);
      }
    }
  };
</script>

<style scoped lang="less">
  .suspension_btn {
    position: fixed;
    bottom: 50px;
    right: 13px;
    cursor: pointer;

    .action_btn {
      position: absolute;
      top: 0;
      right: 0;
      width: 32px;
      height: 32px;
      z-index: 10;
    }

    .code_btn,
    .feeb_back_btn {
      margin-bottom: 12px;
      width: 32px;
      height: 32px;
      box-shadow: 0 0 4px #ddd;
      border-radius: 50%;
    }

    .code_btn {
      background: url("../assets/index/code.png") no-repeat;
      position: relative;
    }

    .action_btn:hover {
      background: url("../assets/index/code_active.png") no-repeat;
    }

    .feeb_back_btn {
      background: url("../assets/index/feedBack.png") no-repeat;
    }

    .feeb_back_btn:hover {
      background: url("../assets/index/feedBack_active.png") no-repeat;
    }

    .top_btn {
      background: url("../assets/index/backTop.png") no-repeat;
      width: 32px;
      height: 32px;
      box-shadow: 0 0 4px #ddd;
      border-radius: 50%;
    }

    .top_btn:hover {
      background: url("../assets/index/backTop_active.png") no-repeat;
      width: 32px;
      height: 32px;
    }
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 1s;
  }

  .fade-leave-to {
    opacity: 0;
  }

  .fade-leave-active {
    transition: opacity 1s;
  }

  .code_view {
    background: url("../assets/index/btn_square.png") no-repeat;
    width: 142px;
    height: 287px;
    position: absolute;
    top: -130px;
    right: 29px;
    padding: 18px 20px 18px 12px;
    text-align: center;
    box-sizing: border-box;

    .code_title {
      font-size: 10px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 15px;
      padding-bottom: 8px;
    }

    .ios_code {
      .img {
        display: block;
        width: 92px;
        height: 92px;
        margin: 0 auto;
      }

      .code_desc {
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
        text-align: center;
      }
    }
  }

  .feed_back_header {
    .close_view {
      float: right;
      cursor: pointer;
    }

    .title_view {
      width: 260px;
      background: #f5f6f6;
      border-radius: 15px;
      margin: 0 auto;
      clear: both;
      padding: 7px 24px;
      box-sizing: border-box;

      .title_left,
      .title_right,
      .title_value {
        display: inline-block;
      }

      .title_value {
        width: 148px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin: 0 16px;
      }
    }
  }

  .title_border {
    border-bottom: 1px solid #f5f6f6;
    width: 420px;
    margin-top: 20px;
  }

  .feed_back_footer {
    padding: 12px 120px 27px 120px;
    box-sizing: border-box;
    width: 100%;

    .btn {
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #008cff;
      padding: 8px 0;
      width: 102px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #008cff;
      text-align: center;
      display: inline-block;
      cursor: pointer;
    }

    .btn_2 {
      color: #ffffff;
      background-color: #008cff;
      margin-left: 16px;
    }
  }

  .feedBackForm {
    padding-top: 16px;

    .el_form_item_title {
      font-size: 12px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 18px;
      padding-bottom: 12px;

      .required_tip {
        color: #ff6165;
      }
    }
  }

  .upload_demo {
    /deep/ .el-upload-dragger {
      width: auto;
      height: auto;
      padding: 0 100px;
    }

    /deep/ .el-upload {
      width: 100%;
    }

    .img_up {
      margin: 51px 0 12px 0;
    }

    .up_tip {
      font-size: 12px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      padding: 9px 0 16px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/toolBtn.vue